export function isQuestion(m) {
  return m.type === 'Question';
}

export function hasError(m) {
  return m.status === 'error';
}

export function isStatusPending(m) {
  return m.status === 'pending';
}

export function isWritingResponse(m) {
  return m.type === 'Answer' && isStatusPending(m) && !m.content;
}

export function isAnswer(m) {
  return m.type === 'Answer' && m.content;
}
